<template>
    <div>
        {{ $t('checkout.cart.itemLabels.attachments') }}
        <div class="has-text-right">
            <div
                class="attachment"
                v-for="(attachment, index) in cartItem.attachments"
                :key="`cart-item_${cartItem._id}__attachment_${index}`"
            >
                <a target="__blank" :href="attachment">{{
                    parseFileName(attachment)
                }}</a>
            </div>
            <div :class="{ 'is-loading': isUploadProcessing }">
                <a class="button" @click="checkAgreement()">{{
                    $t('checkout.cart.itemLabels.uploadAttachment')
                }}</a>
                <input
                    @change="processFile()"
                    type="file"
                    id="3d-file"
                    hidden
                    ref="fileInput"
                />
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { eventBus } from '../../../events/event-bus';

export default {
    name: 'CartItemAttachments',
    data() {
        return {
            isUploadProcessing: false,
            supportsDragAndDrop: false,
            isFileDragging: false,
            uploadProgress: 0,
        };
    },
    props: {
        cartItem: {
            type: Object,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    computed: {
        ...mapGetters(['userPreferences']),
        acceptAttachmentDisclaimer: {
            get() {
                return this.userPreferences.acceptAttachmentDisclaimer.value;
            },
            set(value) {
                this.$store.dispatch('updateUserPreferences', {
                    acceptAttachmentDisclaimer: { value, isSet: true },
                });
            },
        },
    },
    methods: {
        parseFileName(path) {
            let elem = path.split('/');
            return elem[elem.length - 1];
        },
        handleDrop(event) {
            event.preventDefault();
            this.processFile(event.dataTransfer.files[0]);
        },
        checkAgreement() {
            if (this.acceptAttachmentDisclaimer) {
                this.selectFile();
            } else {
                this.$buefy.dialog.confirm({
                    title: 'Hinweis',
                    message: `<p class="is-size-6 has-text-weight-light">Durch den Upload von Zusatzinformationen verlassen Sie unseren vollautomatisierten Online-Bereich.<br><br>
          Unsere Kollegen werden Ihre Dateien zeitnah auf Machbarkeit prüfen und Ihnen hierzu gerne ein Angebot zukommen lassen. Die angezeigten Online-Preise beziehen sich ausschließlich auf die im Shop angebotenen Leistungen. <br><br>Zusätzliche Leistungen, die aus den Zeichnungen hervorgehen, können daher nicht berücksichtigt werden.</p>`,
                    cancelText: 'Abbrechen',
                    confirmText: 'OK - Hochladen',
                    type: 'is-primary-dark',
                    onConfirm: () => {
                        this.acceptAttachmentDisclaimer = true;
                        this.selectFile();
                    },
                });
            }
        },
        selectFile() {
            let clickEvent = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: false,
            });
            this.$refs.fileInput.dispatchEvent(clickEvent);
        },
        processFile(file) {
            this.isUploadProcessing = true;
            this.file = file || this.$refs.fileInput.files[0];

            this.$store
                .dispatch('uploadCartItemAttachments', {
                    id: this.cartItem._id,
                    file: this.file,
                })
                .then(() => {
                    this.isUploadProcessing = false;
                })
                .catch(() => {
                    eventBus.notification({
                        type: 'warning',
                        header: 'Hier scheint ein Fehler aufgetreten zu sein.',
                        body: 'Ihre Anfrage konnte nicht versendet werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
                    });
                });
        },
    },
};
</script>

<style scoped>
.attachment {
    padding-bottom: 1rem;
}
</style>
